<template>
    <v-layout row wrap>
        <v-flex xs12>
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    COP
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12>
                        <vue-plotly disable-responsive :data="data" :layout="layout" :options="{}"/>
                    </v-flex>
                    <v-flex xs12>
                        <vue-plotly disable-responsive :data="data2" :layout="layout2" :options="{}"/>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>

</template>

<script>
    import VuePlotly from '@/components/VuePlotly'

    export default {
        name: 'COP3D',
        components: {VuePlotly},
        computed: {},
        data() {
            return {
                data: [{
                    x: [18, 20, 22, 24, 26, 28, 30, 32, 34],
                    y: [100, 200, 300, 400, 500, 600, 700, 800],
                    z: [
                        [4.641, 4.507, 4.504, 4.355, 4.158, 3.961, 3.853, null, null],
                        [null, 4.640, 4.641, 4.261, 4.249, 4.032, 3.919, 3.770, null],
                        [null, null, 5.333, 4.631, 4.394, 4.111, 4.020, 3.955, null],
                        [null, null, null, 4.779, 4.533, 4.294, 4.094, 3.980, null],
                        [null, null, null, 4.522, 4.488, 4.271, 4.125, 3.984, 3.827],
                        [null, null, null, null, 4.446, 4.377, 4.083, 3.988, 3.777],
                        [null, null, null, null, null, 4.126, 4.000, 3.849, 3.647],
                        [null, null, null, null, null, 4.100, 3.963, 3.852, null]
                    ],
                    type: 'surface',
                    name: "Software Platform",
                    colorscale: 'Blues',
                    showscale: true,
                    colorbar: {
                        title: "Software Platform"
                    }
                },
                    {
                        x: [18, 20, 22, 24, 26, 28, 30, 32, 34],
                        y: [100, 200, 300, 400, 500, 600, 700, 800],
                        z: [
                            [4.490, 4.451, 4.287, 4.047, 4.153, 3.686, 3.922, null, null],
                            [null, 4.384, 4.432, 4.392, 4.055, 3.796, 3.680, 4.159, null],
                            [null, null, 4.810, 4.747, 4.215, 3.903, 3.725, 3.667, null],
                            [null, null, null, 4.654, 4.493, 4.149, 3.815, 3.458, null],
                            [null, null, null, 4.355, 4.401, 4.143, 3.897, 3.638, 3.469],
                            [null, null, null, null, 4.382, 4.175, 3.943, 3.697, 3.539],
                            [null, null, null, null, null, 4.100, 3.926, 3.760, 3.689],
                            [null, null, null, null, null, 4.225, 3.837, 3.717, null]

                        ],
                        type: 'surface',
                        name: "BMS",
                        colorscale: 'Reds',
                        showscale: true,
                        colorbar: {
                            title: "BMS",
                            x: 1.1
                        }
                    }],
                layout: {
                    title: "SHT - COP",
                    height: 800,
                    scene: {
                        xaxis: {
                            title: "Outdoor Air Temperature (°C)"
                        },
                        yaxis: {
                            title: "Cooling Load (kW)"
                        },
                        zaxis: {
                            title: "COP"
                        }
                    },

                },
                data2: [{
                    x: [22, 24, 26, 28, 30],
                    y: [1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000],
                    z: [
                        [5.98, 5.907, 5.629, null, null],
                        [6.648, 6.419, 6.051, 5.878, null],
                        [6.822, 6.658, 6.393, 6.299, null],
                        [5.848, 5.866, 6.209, null, null],
                        [6.141, 6.036, 5.935, null, null],
                        [6.314, 6.247, 6.006, 5.858, null],
                        [6.817, 6.395, 6.185, null, null],
                        [null, 6.571, 6.169, null, null],
                    ],
                    type: 'surface',
                    name: "Software Platform",
                    colorscale: 'Blues',
                    showscale: true,
                    colorbar: {
                        title: "Software Platform"
                    }
                },
                    {
                        x: [22, 24, 26, 28, 30],
                        y: [1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000],
                        z: [
                            [null, 5.962, 5.577, 5.431, null],
                            [null, 6.238, 6.229, 5.684, 4.858],
                            [null, 6.554, 6.229, 6.019, null],
                            [null, null, 6.208, 6.027, null],
                            [null, null, 5.597, 5.443, 4.73],
                            [null, 6.189, 5.895, 5.667, 4.984],
                            [null, 6.242, 6.078, 5.92, 5.121],
                            [null, 6.568, 6.155, 5.985, 5.344],

                        ],
                        type: 'surface',
                        name: "BMS",
                        colorscale: 'Reds',
                        showscale: true,
                        colorbar: {
                            title: "BMS",
                            x: 1.1
                        }
                    }],
                layout2: {
                    title: "CRP - COP",
                    height: 800,
                    scene: {
                        xaxis: {
                            title: "Outdoor Air Temperature (°C)"
                        },
                        yaxis: {
                            title: "Cooling Load (kW)"
                        },
                        zaxis: {
                            title: "COP"
                        }
                    },

                },
            }


        },
    }
</script>

<style scoped>

</style>
